/* eslint-disable custom-rules/function-name-matches-filename */
import type { Middleware, ResponseContext } from '@dynamic-labs/sdk-api-core';

import { APIError } from '../../../../errors/APIError';
import type { ErrorMapper } from '../../apiClient.types';

type CreateConvertToApiErrorMiddlewareOptions = {
  errorMappers?: ErrorMapper[];
};

/**
 * Creates middleware that converts HTTP error responses to APIError instances
 * and optionally applies custom error mappers to transform them into specific error types.
 *
 * @param options.errorMappers - Array of error mappers to apply to API errors
 * @returns A middleware function that handles error conversion and mapping
  * @notInstrumented
 */
export const createConvertToApiErrorMiddleware = ({
  errorMappers = [],
}: CreateConvertToApiErrorMiddlewareOptions): Middleware => ({
  post: async (context: ResponseContext) => {
    if (context.response.status >= 400) {
      const apiError = await APIError.fromResponse(context.response);

      if (apiError) {
        let errorToThrow: Error = apiError;

        for (const mapper of errorMappers) {
          const newError = mapper(apiError);

          if (newError) {
            errorToThrow = newError;
            break;
          }
        }

        throw errorToThrow;
      }
    }

    return context.response;
  },
});
